export default __webpack_public_path__ + "static/media/Sandals of Indomitable Souls.1fc67f6a.jpg";